import React from 'react';
import PropTypes from 'prop-types';
import {ListGroup} from "reactstrap";
import TreeMenuNewItem from "./TreeMenuNewItem";
import {DISPLAY_TYPE_BREADCRUMB} from "./TreeMenuNew";
import {useTreeMenuNew} from "./TreeMenuNewContext";

const TreeMenuNewList = props => {
  const {displayType} = useTreeMenuNew()
  const hasActiveItem = () => {
    return props.items.find(item => item.acctive)
  }

  return (
    <ListGroup className={`tree-menu ${props.className}`}>
      {props.items.map(item => {
        if(displayType === DISPLAY_TYPE_BREADCRUMB && hasActiveItem() && !item.acctive){
          return null
        }

        return <TreeMenuNewItem
          key={item.key}
          item={item}
        />
      })}
    </ListGroup>
  );
};

TreeMenuNewList.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    acctive: PropTypes.bool.isRequired,
    key: PropTypes.string.isRequired,
  })),
};

export default TreeMenuNewList;